export const QUERY_KEYS = {
  AUTH0_LOGIN: 'auth0-login',
  // ACCOUNT_DATA powers the canonical query skeleton (useAccountQuery).
  // Single hydration point for the Cookie Armor shell; rename only if a
  // Cookie Armor concept (workspace, site, etc.) is locked in later.
  ACCOUNT_DATA: 'account-data',
  // BANNER is forward-looking — paired with the create-banner wizard
  // mutation. useCreateBannerMutation.onSuccess will write the created
  // banner to [QUERY_KEYS.BANNER, id] once a banner detail page lands.
  BANNER: 'banner',
  // Banners list dashboard: list cache is separate from per-id BANNER detail.
  BANNERS_LIST: 'banners-list',
  BANNER_STATS: 'banner-stats',
  SITE_SUMMARY: 'site-summary',
  SITE_DAILY: 'site-daily',
  INSTALL_STATUS: 'install-status',
  SCAN_STATUS: 'scan-status',
  SCAN_HISTORY: 'scan-history',
  SCAN_DETAIL: 'scan-detail',
  CONSENT_DETAIL: 'consent-detail',
  // Settings account members list: admin team members table.
  ACCOUNT_MEMBERS_LIST: 'account-members-list',
  // Public invite token verification (AcceptInvite pre-login page).
  INVITE_VERIFICATION: 'invite-verification',
}

export const MUTATION_KEYS = {
  CREATE_BANNER: 'createBanner',
  TRIGGER_SCAN: 'triggerScan',
  OVERRIDE_SCAN_CATEGORY: 'overrideScanCategory',
  UPDATE_BANNER: 'updateBanner',
  DELETE_BANNER: 'deleteBanner',
  SUBMIT_SUPPORT: 'submit-support',
  UPDATE_ACCOUNT: 'updateAccount',
  SETUP_ACCOUNT: 'setupAccount',
  PATCH_ACCOUNT: 'patchAccount',
  RENAME_ACCOUNT: 'renameAccount',
  COMPLETE_ONBOARDING: 'completeOnboarding',
  ADD_ACCOUNT_MEMBER: 'addAccountMember',
  UPDATE_ACCOUNT_MEMBER_ROLE: 'updateAccountMemberRole',
  REMOVE_ACCOUNT_MEMBER: 'removeAccountMember',
  DELETE_ACCOUNT: 'deleteAccount',
  LEAVE_ACCOUNT: 'leaveAccount',
}

export const CACHE_TIMES = {
  xs: 1000 * 60 * 2,
  sm: 1000 * 60 * 5,
  md: 1000 * 60 * 10,
  lg: 1000 * 60 * 20,
  xl: 1000 * 60 * 30,
  endless: Infinity,
}

export const STALE_TIMES = {
  xs: 1000 * 10,
  sm: 1000 * 30,
  md: 1000 * 60 * 2,
  lg: 1000 * 60 * 5,
  xl: 1000 * 60 * 10,
  endless: Infinity,
}
